import { TError } from '@ws/shared/types';
import { getErrorMessage } from '@ws/shared/utils';

export function createApiActionError(error: unknown): TError {
  return { errorMessage: getErrorMessage(error) };
}
